import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import chunk from 'lodash/chunk';
import { Sponsor } from '../../../types/event.types';
import { ORGANIZATIONS_PATH } from '../../../utilities/devex_paths';
const CLOUDINARY_PATH = 'https://res.cloudinary.com/devex/image/fetch/c_thumb,w_190,f_auto,q_auto/';
import styles from './partners_section.module.scss';

const PartnersSection: React.FC = () => {
  const { sponsors } = useContext(EventDetailsContext);
  const renderedSponsors: Array<Sponsor[]> = Array.isArray(sponsors[0])
    ? sponsors
    : chunk(sponsors, 3);

  const renderHeading: JSX.Element = Array.isArray(sponsors[0]) ? null : (
    <h2 className='mb-0 py-1 border-bottom'>Partners</h2>
  );

  const renderSponsorRow = (row: Sponsor[]): JSX.Element[] =>
    row.map((sponsor: Sponsor) => (
      <div className='col-lg-4 col-12' key={sponsor.id}>
        <div className='m-35 d-flex justify-content-center'>
          <a
            href={`${ORGANIZATIONS_PATH}/${sponsor.slug_and_id}`}
            target='_blank'
            aria-label={`${sponsor.name} page`}
            className='link-gray-orange'
            rel='noreferrer'
          >
            {sponsor.logo ? (
              <img src={`${CLOUDINARY_PATH}${sponsor.logo}`} alt={sponsor.name} />
            ) : (
              <h4 className='fs-55 mx-lg-5 mb-0'>{sponsor.name}</h4>
            )}
          </a>
        </div>
      </div>
    ));

  const renderSponsorsWithoutTypes: JSX.Element[] = renderedSponsors.map(
    (row: Sponsor[], idx: number) => {
      return (
        <div className='row mt-lg-25 d-flex justify-content-evenly align-items-center' key={idx}>
          {renderSponsorRow(row)}
        </div>
      );
    }
  );

  const renderSponsorsWithTypes: JSX.Element[] = renderedSponsors.map(
    (sponsorArray, index: number) => (
      <div key={index} className={`my-lg-4 py-3 ${styles.whiteContainer}`}>
        <h3 className='fs-4 py-15 mb-0 text-center text-gray-li'>
          {sponsorArray[0]?.partnership_type}
        </h3>
        {chunk(sponsorArray, 3).map((row: Sponsor[], idx: number) => (
          <div className='row mt-lg-4 d-flex justify-content-evenly align-items-center' key={idx}>
            {renderSponsorRow(row)}
          </div>
        ))}
      </div>
    )
  );

  const renderPartners: JSX.Element | JSX.Element[] = Array.isArray(sponsors[0]) ? (
    renderSponsorsWithTypes
  ) : (
    <div className='pt-25'>{renderSponsorsWithoutTypes}</div>
  );

  return sponsors.length ? (
    <div id='partners' className={`py-5 ${styles.partners}`}>
      <div className={`container ${styles.limitedWidthForContainer}`}>
        <div className='row'>
          <div className='col'>
            {renderHeading}
            {renderPartners}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default PartnersSection;
